import React from 'react'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const TermsAndConditionsCopy = () => {
  return (
    <Typography>
      {'By checking this box you agree to '}
      <Link href='https://www.arpari.com/legal/terms-of-service' underline='hover'>
        Our Terms of Service
      </Link>
      {' and '}
      <Link href='https://www.arpari.com/legal/privacy-policy' underline='hover'>
        Privacy Policy
      </Link>
      {' as well as our Vendor '}
      <Link href='https://www.dwolla.com/legal/tos/' underline='hover'>
        Dwolla's Terms of Service
      </Link>
      {' and '}
      <Link href='https://www.dwolla.com/legal/privacy/' underline='hover'>
        Privacy Policy
      </Link>
      {'.'}
    </Typography>
  )
}

export default TermsAndConditionsCopy
